<template>
  <v-card class="ma-0 pa-0" elevation="0">
    <material-card
      class="v-card-profile ma-0 mt-7"
      :avatar="file == null ? src : avatar"
    >
      <v-card-text class="text-center">
        <h6 class="display-1 mb-1 grey--text">
          {{ $t("employees.update.imageTitle") }}
        </h6>
        <v-row>
          <v-col cols="12" md="10">
            <v-file-input
              dense
              prepend-icon="mdi-camera"
              accept="image/png, image/jpeg, image/bmp"
              v-model="file"
              ref="avatar"
              :label="$t('employees.input.img')"
              @change="getBase64"
            ></v-file-input
          ></v-col>
          <v-col cols="12" md="2">
            <v-btn outlined color="primary" block @click="saveAvatar">
              {{ $t("btn.save") }}
            </v-btn></v-col
          >
        </v-row>
      </v-card-text>
    </material-card>
  </v-card>
</template>

<script>
import MaterialCard from "@/views/components/MaterialCard.vue";
import cl from "@/services/employee.js";
export default {
  name: "profile-img",
  props: ["src", "id"],
  components: { MaterialCard },
  data() {
    return {
      avatar: null,
      file: null,
      rules: {
        required: null,
      },
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
  },

  methods: {
    saveAvatar() {
      if (this.file == null) return;
      const payload = new FormData();
      payload.append("avatar", this.file);
      cl.uploadAvatar(this.id, payload).then((res) => {
        //   this.$store.dispatch("alert/uploadAvatar", res)
        this.$store.dispatch(
          "handleServiceException",
          { e: res },
          { root: true }
        );
      });
    },
    getBase64(file) {
      try {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatar = e.target.result;
        };
        reader.readAsDataURL(file);
        //this.$emit("set_img_profile", this.file);
      } catch (e) {}
    },
  },
};
</script>
